module.exports = __webpack_public_path__ + "static/media/3.31828790.png";